import {
  BookOpen,
  Briefcase,
  Building2,
  Clock,
  FileSignature,
  LayoutTemplate,
  type LucideIcon,
  Receipt,
  Users,
  Wallet,
} from "lucide-react";

export type NavEntry = { to: string; icon: LucideIcon; label: string };

/** Desktop sidebar sections, shared with the mobile module list. */
export const COMMERCIAL_ENTRIES: NavEntry[] = [
  { to: "/contacts", icon: Users, label: "resources.contacts.name" },
  { to: "/companies", icon: Building2, label: "resources.companies.name" },
  { to: "/deals", icon: Briefcase, label: "resources.deals.name" },
];

export const HUB_ENTRIES: NavEntry[] = [
  { to: "/wiki_pages", icon: BookOpen, label: "resources.wiki_pages.name" },
  { to: "/quotes", icon: FileSignature, label: "resources.quotes.name" },
  { to: "/invoices", icon: Receipt, label: "resources.invoices.name" },
  { to: "/subscriptions", icon: Wallet, label: "resources.subscriptions.name" },
  { to: "/time_entries", icon: Clock, label: "resources.time_entries.name" },
  {
    to: "/delivery_templates",
    icon: LayoutTemplate,
    label: "resources.delivery_templates.name",
  },
];
